import { ReactNativeIpcMessage } from '@/features/mobile-app-bridge/constants/message-action-schema';
import { z } from 'zod';
import downloadFileMessageInput from '@/features/mobile-app-bridge/constants/actions/download-file-message-input';
import saveBase64ToFileMessage from '@/features/mobile-app-bridge/constants/actions/save-base64-to-file-message';
import setSentryUserMessage from '@/features/mobile-app-bridge/constants/actions/set-sentry-user-message';

/**
 * The message schema for the Web app to send messages to the React Native app
 * for processing
 */
export const messageSchema = z.discriminatedUnion('action', [
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.DOWNLOAD_FILE),
    input: downloadFileMessageInput,
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.SAVE_BASE64_DATA_TO_FILE),
    input: saveBase64ToFileMessage,
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.SET_SENTRY_USER),
    input: setSentryUserMessage,
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.UNSET_SENTRY_USER),
    input: z.object({}),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.KV_SET),
    input: z.object({
      key: z.string(),
      value: z.any(),
    }),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.KV_GET),
    input: z.object({
      key: z.string(),
    }),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.KV_REMOVE),
    input: z.object({
      key: z.string(),
    }),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.LOGIN_USER),
    input: z.object({
      username: z.string(),
      password: z.string(),
    }),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.LOGOUT_USER),
    input: z.object({}).optional().nullable(),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.GET_FCM_TOKEN),
    input: z.object({}).optional().nullable(),
  }),
  z.object({
    action: z.literal(ReactNativeIpcMessage.enum.CLEAR_FCM_TOKEN),
    input: z.object({}).optional().nullable(),
  }),
]);

const ipcResponseMessageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('WEBVIEW_IPC_SUCCESS'),
    uuid: z.string(),
    from: z.literal('TIRECLOUD_RN_NATIVE'),
    action: ReactNativeIpcMessage,
    result: z.any(),
  }),
  z.object({
    type: z.literal('WEBVIEW_IPC_ERROR'),
    uuid: z.string(),
    from: z.literal('TIRECLOUD_RN_NATIVE'),
    action: ReactNativeIpcMessage.optional().nullable(),
    error: z.any(),
  }),
  z.object({
    type: z.literal('NATIVE_EVENT'),
    from: z.literal('TIRECLOUD_RN_NATIVE'),
    event: z.enum(['NOTIFICATION_OPENED', 'FCM_TOKEN_REFRESHED']),
    payload: z.record(z.string(), z.unknown()).optional(),
  }),
]);

export type IpcResponseMessage = z.infer<typeof ipcResponseMessageSchema>;
export default ipcResponseMessageSchema;
